module.exports = __webpack_public_path__ + "img/type--2-spans--single-lang--de.e7265c7b.jpg";